import { Field } from "@ark-ui/react/field";
import type { ComponentProps, PropsWithChildren } from "react";

type LabelProps = Omit<ComponentProps<typeof Field.Label>, "className">;
type Props = PropsWithChildren<LabelProps>;

const Label = ({ children, ...rest }: Props) => {
  return (
    <Field.Label {...rest} className="text-label2">
      {children} <Field.RequiredIndicator className="text-red-500" />
    </Field.Label>
  );
};

export default Label;
